module.exports = __webpack_public_path__ + "static/media/inventory-management_SK.ca23d188.md";